/**
 * Which routes render full width, without the sidebar.
 *
 * Listed explicitly so that a new top-level route doesn't become full width by sharing a
 * prefix (e.g. `/site-map` with `/site`).
 */
const FULL_WIDTH_EXACT: readonly string[] = ['/', '/site', '/site-map'];
const FULL_WIDTH_PREFIXES: readonly string[] = ['/site/'];

export function isFullWidthPath(pathname: string): boolean {
  return (
    FULL_WIDTH_EXACT.includes(pathname) ||
    FULL_WIDTH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}
